import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M 4.465 8.5 C 4.465 8.605 4.498 8.711 4.565 8.8 L 10.565 16.8 C 10.731 17.021 11.044 17.066 11.265 16.9 S 11.531 16.421 11.366 16.2 L 5.591 8.5 L 11.366 0.8 C 11.531 0.58 11.486 0.267 11.265 0.1 A 0.5007 0.5007 0 0 0 10.565 0.201 L 4.565 8.201 A 0.503 0.503 0 0 0 4.465 8.501 Z',
  ],
  height: 17,
  width: 16,
});
